/**
 * In-memory product cache with stale-while-revalidate support.
 * Lives at module level so it persists across React re-renders and
 * page navigations within the same browser session.
 */

const CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutes

const cache = new Map(); // key -> { data, timestamp }

/** Build a stable string key from a params object */
export function buildCacheKey(params = {}) {
  const sorted = Object.keys(params)
    .sort()
    .filter(k => params[k] !== undefined && params[k] !== '')
    .map(k => `${k}=${params[k]}`)
    .join('&');
  return sorted || 'default';
}

/** Returns { data, isStale } or null if not cached */
export function getCached(key) {
  const entry = cache.get(key);
  if (!entry) return null;
  const isStale = Date.now() - entry.timestamp > CACHE_TTL_MS;
  return { data: entry.data, isStale };
}

/** Store a result in the cache */
export function setCached(key, data) {
  cache.set(key, { data, timestamp: Date.now() });
}

/** Invalidate all cached entries (e.g. after admin saves a product) */
export function invalidateCache() {
  cache.clear();
}
